
const isProdCache = (() => {
  if (
    window.location.hostname === 'localhost' ||
    window.location.hostname === 'consumer-local.leaguesafe.com' ||
    window.location.hostname.includes('shub.dog') ||
    window.location.hostname.includes('shub.local') ||
    window.location.hostname.includes('leaguesafe.shublocal.com')
  ) {
    return false
  }
  return true
})()

export const isProd = () => isProdCache

export const isLocal = () => {
  return window.location.hostname === 'localhost'
}

export const getENV = () => {
  return isProd() ? 'https://assets.shgn.com' : 'https://assets.shub.dog'
}



// WEBPACK FOOTER //
// ./src/tools/env.js